// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__z2q6F","productName":"Table_productName__1z5Os"};